import { render, staticRenderFns } from "./DataBankMenu.vue?vue&type=template&id=148879fa&scoped=true&"
import script from "./DataBankMenu.vue?vue&type=script&lang=js&"
export * from "./DataBankMenu.vue?vue&type=script&lang=js&"
import style0 from "./DataBankMenu.vue?vue&type=style&index=0&id=148879fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148879fa",
  null
  
)

export default component.exports